import { Injectable } from "@angular/core";

import {
  IDealershipDetails
} from "common";

import { EncriptionService } from "digital-core";

@Injectable({
  providedIn: "root",
})
export class DealerShipDetailService {
  private dealerShipDetails: IDealershipDetails;
  constructor(
    private encriptionService: EncriptionService
  ) {}

  getDealerShipDetails() {
    const dealershipDetails: IDealershipDetails = JSON.parse(
      this.encriptionService.dec(localStorage.getItem("dealerShip_info"))
    ) as IDealershipDetails;
    this.dealerShipDetails = dealershipDetails;
    return this.dealerShipDetails;
  }

  getInsuranceTypeForDealer() {
    const dealershipDetails: IDealershipDetails = JSON.parse(
      this.encriptionService.dec(localStorage.getItem("dealerShip_info"))
    ) as IDealershipDetails;
    this.dealerShipDetails = dealershipDetails;
    return this.dealerShipDetails;
  }

  isMobileDeviceAllowed() {
    if (!this.dealerShipDetails) {
      this.getDealerShipDetails();
    }
    return this.dealerShipDetails?.IsMobile ?? false;
  }

  isGadgetAllowed() {
    if (!this.dealerShipDetails) {
      this.getDealerShipDetails();
    }
    return this.dealerShipDetails?.IsGadget ?? false;
  }
  isRefurbishedAllowed() {
    if (!this.dealerShipDetails) {
      this.getDealerShipDetails();
    }
    return this.dealerShipDetails?.IsRefurbished ?? false;
  }
  isAllProgramTypeAllowed() {
    if (!this.dealerShipDetails) {
      this.getDealerShipDetails();
    }
    return this.dealerShipDetails.IsGadget && this.dealerShipDetails.IsMobile;
  }
  isServiceOffer() {
    if (!this.dealerShipDetails) {
      this.getDealerShipDetails();
    }
    return this.dealerShipDetails?.IsServiceOffer ?? false;
  }
}
